import ProfileSetting from './ProfileSetting';
import SecuritySetting from './SecuritySetting';
import NotificationSetting from './NotificationSetting';

export { ProfileSetting, SecuritySetting, NotificationSetting };
